import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Input,
  Label,
  Table
} from "reactstrap";
import Flatpickr from "react-flatpickr";
import { postDataAPI } from "../../helpers/phpbackend_helper";

const DAYS = [
  "Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"
];

const IMPACT_OPTIONS = [
  { label: "Positive Impact", value: "positive" },
  { label: "Negative Impact", value: "negative" },
  { label: "Neutral", value: "neutral" }
];

export default function EventModal({
  isOpen,
  toggle,
  onSave,
  editing,
  initialData,
  servicePeriods,
  loading,
  onDelete,
  onDuplicate
}) {
  const [form, setForm] = useState({
    name: "",
    fromDate: null,
    tillDate: null,
    days: DAYS,
    servicePeriod: "",
    startTime: null,
    endTime: null,
    closed: false,
    area: "",
    areaUnit: "sq.ft",
    duration: "",
    impact: "",
    capacity: [],
    notes: ""
  });

// useEffect(() => {
//   if (editing && initialData) {
//     const desc = initialData.resource || {};

//     let capacityRows = [];
//     if (desc.capacity) {
//       try {
//         const parsed = JSON.parse(desc.capacity);
//         capacityRows = parsed.count.map((c, i) => ({
//           tables: c,
//           seats: parsed.seats[i]
//         }));
//       } catch (e) {
//         capacityRows = [];
//       }
//     }

//     const dowMap = {
//       "1": "Monday",
//       "2": "Tuesday",
//       "3": "Wednesday",
//       "4": "Thursday",
//       "5": "Friday",
//       "6": "Saturday",
//       "7": "Sunday"
//     };

//     let selectedDays = [];
//     if (desc.applicable_to) {
//       const spKey = Object.keys(desc.applicable_to)[0];
//       selectedDays =
//         desc.applicable_to[spKey]?.day?.map(d => dowMap[d]) || [];
//     }

//     setForm({
//       name: desc.event_name || "",
//       fromDate: desc.from_dt ? new Date(desc.from_dt) : null,
//       tillDate: desc.to_dt ? new Date(desc.to_dt) : null,
//       days: selectedDays,
//       servicePeriod: desc.sp_id || "",
//       startTime: desc.start_time
//         ? new Date(`1970-01-01T${desc.start_time}`)
//         : null,
//       endTime: desc.end_time
//         ? new Date(`1970-01-01T${desc.end_time}`)
//         : null,
//       closed: desc.is_holiday === "1",
//       area: desc._area || "",
//       areaUnit: desc.area_unit || "sq.ft",
//       duration: desc.dining_time || "",
//       impact: desc.impacts_forecast || "",
//       capacity: capacityRows,
//       notes: desc.event_note || ""
//     });

//   } else if (!editing && isOpen) {
//     // ✅ RESET FORM WHEN ADD MODE OPENS
//     setForm({
//       name: "",
//       fromDate: null,
//       tillDate: null,
//       days: DAYS,
//       servicePeriod: "",
//       startTime: null,
//       endTime: null,
//       closed: false,
//       area: "",
//       areaUnit: "sq.ft",
//       duration: "",
//       impact: "",
//       capacity: [],
//       notes: ""
//     });
//   }

// }, [initialData, editing, isOpen]);
useEffect(() => {

  if (initialData) {

    const desc = initialData.resource || {};

    let capacityRows = [];
    if (desc.capacity) {
      try {
        const parsed = JSON.parse(desc.capacity);
        capacityRows = parsed.count.map((c, i) => ({
          tables: c,
          seats: parsed.seats[i]
        }));
      } catch (e) {
        capacityRows = [];
      }
    }

    const dowMap = {
      "1": "Monday",
      "2": "Tuesday",
      "3": "Wednesday",
      "4": "Thursday",
      "5": "Friday",
      "6": "Saturday",
      "7": "Sunday"
    };

    let selectedDays = [];
    if (desc.applicable_to) {
      const spKey = Object.keys(desc.applicable_to)[0];
      selectedDays =
        desc.applicable_to[spKey]?.day?.map(d => dowMap[d]) || [];
    }

    setForm({
      name: desc.event_name || "",
      fromDate: desc.from_dt ? new Date(desc.from_dt) : null,
      tillDate: desc.to_dt ? new Date(desc.to_dt) : null,
      days: selectedDays,
      servicePeriod: desc.sp_id || "",
      startTime: desc.start_time
        ? new Date(`1970-01-01T${desc.start_time}`)
        : null,
      endTime: desc.end_time
        ? new Date(`1970-01-01T${desc.end_time}`)
        : null,
      closed: desc.is_holiday === "1",
      area: desc._area || "",
      areaUnit: desc.area_unit || "sq.ft",
      duration: desc.dining_time || "",
      impact: desc.impacts_forecast || "",
      capacity: capacityRows,
      notes: desc.event_note || ""
    });

  } else if (isOpen) {

    setForm({
      name: "",
      fromDate: null,
      tillDate: null,
      days: DAYS,
      servicePeriod: "",
      startTime: null,
      endTime: null,
      closed: false,
      area: "",
      areaUnit: "sq.ft",
      duration: "",
      impact: "",
      capacity: [],
      notes: ""
    });

  }

}, [initialData, isOpen]);

  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
  };

  const toggleDay = (day) => {
    const exists = form.days.includes(day);
    handleChange(
      "days",
      exists
        ? form.days.filter(d => d !== day)
        : [...form.days, day]
    );
  };

  const addCapacityRow = () => {
    handleChange("capacity", [
        ...form.capacity,
        { tables: "", seats: "" }
    ]);
};

  const updateCapacity = (index, field, value) => {
    const updated = [...form.capacity];
    updated[index][field] = value;
    handleChange("capacity", updated);
  };

  const removeCapacityRow = (index) => {
    handleChange(
      "capacity",
      form.capacity.filter((_, i) => i !== index)
    );
  };

  const handleSubmit = () => {
    const formattedData = {
        ...form,
        id: initialData?.id,
        title: form.name,
        start: form.fromDate,
        end: form.tillDate
    };

    onSave(formattedData);
    };

    const handleServicePeriodChange = async (sp) => {
        handleChange("servicePeriod", sp.sp_id);

        try {

            const response = await postDataAPI({
                serviceName: "service_period_data",
                op: "get_default_sp_day",
                sp_id: sp.sp_id,
                days: form.days.map(day =>
                 DAYS.indexOf(day) + 1
                )
            });
    
            if (response.status === "ok") {
                const data = await response.data;
                if (data && data.length > 0) {
                    const res = data[0];

                    // ✅ Parse capacity JSON
                    let capacityRows = [];
                    if (res.capacity) {
                        const parsed = JSON.parse(res.capacity);
                        capacityRows = parsed.count.map((c, i) => ({
                        tables: c,
                        seats: parsed.seats[i]
                        }));
                    }

                    setForm(prev => ({
                        ...prev,
                        startTime: new Date(`1970-01-01T${res.start_time}`),
                        endTime: new Date(`1970-01-01T${res.end_time}`),
                        duration: res.dining_time,
                        area: res.area,
                        areaUnit: res.area_unit,
                        capacity: capacityRows
                    }));
                }
            }
        } catch (error) {
            console.error("Service Period API error:", error);
        }
        };

        useEffect(() => {
        if (form.servicePeriod && !editing) {
            handleServicePeriodChange(
                servicePeriods.find(sp => sp.sp_id === form.servicePeriod)
            );
        }
        }, [form.days]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl">
      <ModalHeader toggle={toggle}>
        {editing ? "Edit Event" : "Add Event"}
      </ModalHeader>

      <ModalBody>

        {/* Event Name + Dates */}
        <Row className="mb-3">
          <Col md="4">
            <Label>Event Name</Label>
            <Input
              value={form.name}
              onChange={(e) => handleChange("name", e.target.value)}
            />
          </Col>

          <Col md="4">
            <Label>From Date</Label>
            <Flatpickr
              className="form-control"
              value={form.fromDate}
              onChange={(date) => handleChange("fromDate", date[0])}
            />
          </Col>

          <Col md="4">
            <Label>Till Date</Label>
            <Flatpickr
              className="form-control"
              value={form.tillDate}
              onChange={(date) => handleChange("tillDate", date[0])}
            />
          </Col>
        </Row>

        {/* Days */}
        <div className="mb-3">
            <Label>Day of the Week</Label>
            <div className="d-flex flex-wrap gap-3 mt-2">
                {DAYS.map((day, index) => {
                const id = `day-${index}`;

                return (
                    <div key={day} className="form-check">
                    <Input
                        type="checkbox"
                        id={id}
                        className="form-check-input"
                        checked={form.days.includes(day)}
                        onChange={() => toggleDay(day)}
                    />
                    <Label
                        for={id}
                        className="form-check-label"
                        style={{ cursor: "pointer" }}
                    >
                        {day}
                    </Label>
                    </div>
                );
                })}
            </div>
</div>

        {/* Service Period */}
        <div className="mb-3">
          <Label>Service Periods</Label>
          <div className="d-flex gap-3">
            {servicePeriods.map(sp => (
                <div key={sp.sp_id}>
                    <Input
                    type="radio"
                    name="servicePeriod"
                    checked={form.servicePeriod === sp.sp_id}
                    onChange={() => handleServicePeriodChange(sp)}
                    />{" "}
                    {sp.title}
                </div>
                ))}
          </div>
        </div>

        {/* Time + Closed */}
        <Row className="mb-3">
          <Col md="3">
            <Label>Start Time</Label>
            <Flatpickr
              className="form-control"
              options={{ enableTime: true, noCalendar: true, dateFormat: "H:i" }}
              value={form.startTime}
              onChange={(date) => handleChange("startTime", date[0])}
            />
          </Col>

          <Col md="3">
            <Label>End Time</Label>
            <Flatpickr
              className="form-control"
              options={{ enableTime: true, noCalendar: true, dateFormat: "H:i" }}
              value={form.endTime}
              onChange={(date) => handleChange("endTime", date[0])}
            />
          </Col>

          <Col md="2">
            <Label className="d-block">Closed:</Label>
            <div className="form-check mt-2">
                <Input
                type="checkbox"
                className="form-check-input"
                id="closedCheck"
                checked={form.closed}
                onChange={(e) => {
                    const isClosed = e.target.checked;

                    setForm(prev => ({
                        ...prev,
                        closed: isClosed,
                        ...(isClosed && {
                        area: "",
                        duration: "",
                        capacity: []
                        })
                    }));
                }}
                />
                <Label for="closedCheck" className="form-check-label">
                Closed
                </Label>
            </div>
            </Col>
        </Row>

        {/* Area + Duration + Impact */}
        {!form.closed && (
        <>
        <Row className="mb-3">
          <Col md="3">
            <Label>Area</Label>
            <div className="input-group">
                <Input
                type="number"
                value={form.area}
                onChange={(e) => handleChange("area", e.target.value)}
                />
                <Input
                type="select"
                value={form.areaUnit}
                onChange={(e) => handleChange("areaUnit", e.target.value)}
                style={{ maxWidth: "120px" }}
                >
                <option value="sq.ft">Sq Feet</option>
                <option value="sq.meter">Sq Meters</option>
                </Input>
            </div>
            </Col>

          <Col md="3">
            <Label>Dining Duration (Minutes)</Label>
            <Input
              type="number"
              value={form.duration}
              onChange={(e) => handleChange("duration", e.target.value)}
            />
          </Col>

          <Col md="3">
            <Label>Is impacts forecast?</Label>
            <Input
              type="select"
              value={form.impact}
              onChange={(e) => handleChange("impact", e.target.value)}
            >
              <option value="">Select</option>
              {IMPACT_OPTIONS.map(opt => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Input>
          </Col>
        </Row>
        
        <div className="mb-3">
          <div className="d-flex justify-content-between align-items-center">
            <Label>Capacity</Label>
            <Button size="sm" color="primary" onClick={addCapacityRow}>
              + Add
            </Button>
          </div>

          <Table bordered size="sm" className="mt-2">
            <thead>
              <tr>
                <th>Seat Capacity</th>
                <th>Tables</th>
                <th>Seats</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
                {form.capacity.map((row, index) => {
                    const seatCapacity = Number(row.seats || 0);
                    const tables = Number(row.tables || 0);
                    const totalSeats = seatCapacity * tables;

                    return (
                    <tr key={index}>
                        <td>
                        <Input
                            value={row.seats}
                            onChange={(e) =>
                            updateCapacity(index, "seats", e.target.value)
                            }
                        />
                        </td>

                       
                        <td>
                        <Input
                            value={row.tables}
                            onChange={(e) =>
                            updateCapacity(index, "tables", e.target.value)
                            }
                        />
                        </td>

                        
                        <td>
                        <Input
                            value={totalSeats}
                            disabled
                        />
                        </td>

                        <td>
                        <Button
                            size="sm"
                            color="danger"
                            onClick={() => removeCapacityRow(index)}
                        >
                            X
                        </Button>
                        </td>
                    </tr>
                    );
                })}
                 
                {form.capacity.length > 0 && (() => {
                    const totalTables = form.capacity.reduce(
                    (sum, row) => sum + Number(row.tables || 0),
                    0
                    );

                    const totalSeats = form.capacity.reduce(
                    (sum, row) =>
                        sum + (Number(row.tables || 0) * Number(row.seats || 0)),
                    0
                    );

                    return (
                    <tr style={{ background: "#f8f9fa", fontWeight: "600" }}>
                        <td className="text-end">Total</td>
                        <td>{totalTables}</td>
                        <td>{totalSeats}</td>
                        <td></td>
                    </tr>
                    );
                })()}
            </tbody>
          </Table>
        </div>
        </>
        )}
        {/* Notes */}
        <div>
          <Label>Notes</Label>
          <Input
            type="textarea"
            value={form.notes}
            onChange={(e) => handleChange("notes", e.target.value)}
          />
        </div>

      </ModalBody>

      <ModalFooter>
        {editing && (
          <>
          {/* <Button
            color="warning"
            onClick={onDuplicate}
            disabled={loading}
          >
            Duplicate
          </Button> */}
          <Button
            color="danger"
            onClick={onDelete}
            disabled={loading}
          >
            Delete Event
          </Button>
          </>
        )}
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSubmit} disabled={loading}>
        {loading ? "Saving..." : "Save"}
        </Button>
      </ModalFooter>
    </Modal>
  );
}